import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { encodeId, generateCalanderMonthView } from "utils";
import moment from "moment";
import constants from "../../../../../../../constants";
import styles from "../../../../Scheduler.module.scss";
import { withTranslation } from "react-i18next";
import toast from "react-hot-toast";
import toastHot from "react-hot-toast";
import Loader from "components/Loader";
import { useHistory } from "react-router-dom";
import { getWeekDay } from "utils";
import MoveToApp from "accountOwner/pages/Scheduler/components/Modals/MoveToApp";
import HolidayImage from "../../../../../../../assets/images/early_on.svg";
import AccountImage from "../../../../../../../assets/images/account_circle.svg";
import SelectOfficeModal from "accountOwner/pages/Scheduler/components/Modals/SelectOfficeModal";
import { ThreeDots } from "react-bootstrap-icons";
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import {
  MoreTagsFunction,
  renderOfficeNameOrEnterprise,
  setterCustomSchduler,
  setterPublishOffices,
  matchedBothPatternValues,
  matchedBothDatesValues,
} from "accountOwner/pages/AddEvent/addEvents.functions";
import InviteesPopup from "accountOwner/pages/EventDetails/components/Modals/InviteesPopup";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { showTime } from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab";
import { leaveClasses } from "accountOwner/pages/Scheduler/scheduler.function";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import {
  updateBusySlot,
  useCreateUpdateSchedulerEventMutation,
  getEventListDetails,
  getBusySlot,
} from "repositories/scheduler-repository";
import { useQueryClient } from "react-query";
import { getOfficeDetail } from "repositories/office-repository";
import { addEditEventsConst } from "accountOwner/pages/AddEvent/addEvents.constants";
import EditOptionsModal, {
  editTypesVariables,
} from "accountOwner/pages/EditEvent/EditOptionsModal";
import { splitAllDayAndTimedEvents } from "./agendaView.helpers";
import { formatBusySlotTimeValue } from "./busySlotTime.helpers";

function MonthlyViewNew({
  t,
  currentDate,
  currentUserId,
  viewSettingFilter,
  setDateRange,
  agenda,
  isLoading,
  isFetching,
  error,
  selectedOwnerId,
  isStaff,
  canShowOfficeName,
  isFromDashBoard,
}) {
  const history = useHistory();
  const {
    profile,
    isStaff: isStaffFromContext,
    isOwner,
    dataAccessValues,
    effectiveOwnerId: selectedOwnerIdFromContext,
    effectiveOwnerIdString,
  } = useAccountOwnerCommon();
  const weekDays = constants.weekday;
  const [, setmonthDates] = useState([]);
  const startDate = moment(currentDate)
    .startOf("month")
    .startOf("isoweek")
    .format("YYYY-MM-DD");
  const [popupList, setPopupList] = useState({});
  const [isModal, setIsModal] = useState({ open: false });
  const [showOfficeSelectModal, setShowOfficeSelectModal] = useState(false);
  const [SelectedDateForLeave, setSelectedDateForLeave] = useState(null);
  const [hoverBusySlotKey, setHoverBusySlotKey] = useState("");
  const [nonInvitePopup, setNonInvitePopup] = useState(false);
  const [invitePopupPosition, setInvitePopupPosition] = useState({
    top: 0,
    right: 0,
  });

  // Drag and drop state
  const [draggedEvent, setDraggedEvent] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [dragPreviewDate, setDragPreviewDate] = useState(null);
  const [editModalConfirmation, setEditModalConfirmation] = useState(false);
  const [pendingDragUpdate, setPendingDragUpdate] = useState(null);
  const [isDragDropLoading, setIsDragDropLoading] = useState(false);
  const draggedEventRef = useRef(null);
  const createSchedulerEventMutation = useCreateUpdateSchedulerEventMutation();
  const queryClient = useQueryClient();
  const finalSelectedOwnerId =
    selectedOwnerId || selectedOwnerIdFromContext || profile?.id;

  const draggedEventDateRef = useRef(null);

  const handlePopupToggle1 = (event, setter, hoverbusykey = "") => {
    event.stopPropagation();
    setHoverBusySlotKey(hoverbusykey);
    setInvitePopupPosition({
      top: 50,
      right: 0,
    });
    setter((prev) => !prev);
  };

  const { search } = useLocation();
  const dateMatchForHighlight = useMemo(() => {
    const searchValue = new URLSearchParams(search).get(showTime);
    if (searchValue?.includes("NaN") || !search) {
      return null;
    }
    return new Date(+searchValue);
  }, [search]);

  let filteredAgenda = agenda;

  useEffect(() => {
    if (!isLoading && !isFetching && error?.message) {
      toast.error(error.message);
    }
    //eslint-disable-next-line
  }, [error]);

  useEffect(() => {
    calanderDates(currentDate);
  }, [startDate]);

  const calanderDates = (dateCurrent) => {
    if (dateCurrent) {
      let dates = generateCalanderMonthView(dateCurrent);
      setDateRange({
        startDate: moment(dateCurrent)
          .startOf("month")
          .startOf("isoweek")
          .format("YYYY-MM-DD"),
        endDate: moment(dateCurrent).endOf("month").format("YYYY-MM-DD"),
      });
      setmonthDates([...dates]);
    }
  };

  // Calculate new date for monthly view (preserving time)
  const calculateNewDateForMonthly = useCallback(
    (eventItem, targetDateString) => {
      if (!eventItem || !targetDateString) {
        return null;
      }

      const newDate = moment(targetDateString).startOf("day");

      // Get original date
      let originalDate = null;
      if (eventItem.date) {
        originalDate = moment(eventItem.date).startOf("day");
      } else if (eventItem.startTime) {
        originalDate = moment(eventItem.startTime).startOf("day");
      }

      // Check if same date
      if (originalDate && newDate.isSame(originalDate, "day")) {
        return null;
      }

      // Preserve original time
      let newStartTime, newEndTime;
      if (
        eventItem.isAllDayEvent ||
        eventItem.isAllDayBusy ||
        !eventItem.startTime ||
        !eventItem.endTime
      ) {
        // All-day event
        newStartTime = newDate.startOf("day").toDate();
        newEndTime = newDate.endOf("day").toDate();
      } else {
        // Preserve time from original event
        const originalStart = moment(eventItem.startTime);
        const originalEnd = moment(eventItem.endTime);
        const originalHour = originalStart.hour();
        const originalMinute = originalStart.minute();
        const originalEndHour = originalEnd.hour();
        const originalEndMinute = originalEnd.minute();

        newStartTime = newDate
          .hour(originalHour)
          .minute(originalMinute)
          .second(0)
          .toDate();
        newEndTime = newDate
          .hour(originalEndHour)
          .minute(originalEndMinute)
          .second(0)
          .toDate();
      }

      return {
        newDate: newDate.toDate(),
        newStartTime: newStartTime,
        newEndTime: newEndTime,
        newStartTimeString: moment(newStartTime).format("YYYY-MM-DDTHH:mm"),
        newEndTimeString: moment(newEndTime).format("YYYY-MM-DDTHH:mm"),
      };
    },
    [],
  );

  // Helper to check if time changed
  const getTimeCheck = useCallback((alreadyTime, selectedTime) => {
    if (alreadyTime) {
      const selectedStartTime = moment(selectedTime);
      const alreadySelectedStartTime = moment(alreadyTime);
      if (
        selectedStartTime.hour() !== alreadySelectedStartTime.hour() ||
        selectedStartTime.minute() !== alreadySelectedStartTime.minute()
      ) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  }, []);

  const handleEventList = (item, list, index, childIndex, date) => {
    setPopupList({
      id: list.id + index + childIndex,
      index: index,
      item: item,
      date: date,
    });
  };

  const getUsefulInfo = (item) => {
    const id = item?.id;
    const officeName = renderOfficeNameOrEnterprise(item, t);
    let title = item?.title || item?.reasonForBlock || null;
    title =
      title && title.length > constants.agendaTitleLength
        ? title.slice(0, constants.agendaTitleLength).concat(" ...")
        : title;
    const timezoneCode = item?.timezoneCode || null;
    const isAllDayEvent = item?.isAllDayEvent;
    const timeString = item?.isAllDayEvent
      ? t("scheduler.agenda.allDayEvent")
      : moment(item?.startTime).format("h:mm A") +
        " - " +
        moment(item?.endTime).format("h:mm A");
    //sepecific to Schedular events
    const createdByMe = item.createdById === currentUserId;
    const isInvite = !!item.eventEmployeeStatus;
    const status = item.eventEmployeeStatus || item.eventRequestToJoinStatus;
    const patientName = item?.patientFullName;
    const location = item?.location;
    let backgroudColorClass;
    backgroudColorClass = createdByMe
      ? ""
      : status === constants.SCHEDULERSTATUS.PENDING
        ? "color-blue"
        : "color-grey";
    return {
      officeName,
      title,
      timezoneCode,
      timeString,
      id,
      isAllDayEvent,
      createdByMe,
      isInvite,
      status,
      backgroudColorClass,
      patientName,
      location,
    };
  };

  const boxBgColor = (type, item) => {
    switch (type) {
      case constants.agendaType.EVENT: {
        return "theme-green-bg";
      }
      case constants.agendaType.BUSY_SLOT:
      case constants.agendaType.BLOCKED: {
        return "light-orange-bg";
      }
      case constants.agendaType.APPOINTMENT: {
        return "light-purple-bg";
      }
      case constants.agendaType.LEAVE: {
        return "light-red-bg";
      }
      default: {
        return null;
      }
    }
  };

  const goToDetails = (id, type, createdByMe, isInvite, requestedDate) => {
    if (!id || !type) return;
    switch (constants.agendaType[type]) {
      case constants.agendaType.EVENT: {
        let pathname = "/";
        pathname = createdByMe
          ? constants.routes.scheduler.eventDetails.replace(
              ":eventId",
              encodeId(id),
            )
          : isInvite
            ? constants.routes.scheduler.eventRequestDetails.replace(
                ":eventId",
                encodeId(id),
              )
            : constants.routes.scheduler.EventWorkingDetails.replace(
                ":eventId",
                encodeId(id),
              );
        history.push({
          pathname,
          state: { requestedDate },
          search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
        });
        break;
      }
      case constants.agendaType.BUSY_SLOT: {
        const pathname = constants.routes.scheduler.busySlotDetail.replace(
          ":busySlotId",
          encodeId(id),
        );
        history.push({
          pathname,
          state: { requestedDate },
          search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
        });
        break;
      }
      default: {
        return;
      }
    }
  };

  const canEditAndViewOthersData = useCallback(
    (officeId) => {
      if (isStaff || isStaffFromContext) {
        return (
          dataAccessValues?.officeList?.some(
            (res) => res.officeId === officeId && res.isAdmin,
          ) || false
        );
      }
      return isOwner;
    },
    [isStaff, isStaffFromContext, isOwner, dataAccessValues?.officeList],
  );

  // Check if event/shift/busy slot can be dragged
  const canDragEvent = useCallback(
    (item) => {
      if (!item) return false;

      const createdByMe = item.createdById === currentUserId;
      const createdByOthers =
        item?.isShift && profile?.id !== item?.createdById;

      // Check if user is admin or owner
      const isAdmin = profile?.isAdmin;
      const isAccountOwner =
        profile && profile?.role
          ? profile.role.systemRole === constants.systemRoles.accountOwner
          : false;
      const canEditOthers = isAccountOwner || isAdmin;

      // For shifts
      if (item.isShift) {
        if (createdByMe) {
          return true;
        }

        if (createdByOthers) {
          if (canEditOthers) {
            return true;
          }

          if (
            canEditAndViewOthersData &&
            canEditAndViewOthersData(item?.officeId)
          ) {
            return true;
          }

          if (item.eventEmployees && Array.isArray(item.eventEmployees)) {
            const isAssignedToMe = item.eventEmployees.some(
              (emp) =>
                emp.userId === currentUserId ||
                emp.id === currentUserId ||
                emp.user?.id === currentUserId,
            );
            if (isAssignedToMe) {
              return true;
            }
          }

          if (item.userId === currentUserId) {
            return true;
          }
        }
        return false;
      }

      // For busy slots (match WeeklyListView logic)
      const isBusySlot =
        item.agendaType === constants.agendaType.BUSY_SLOT ||
        item.isBusySlot === true;
      const isBlocked = item.agendaType === constants.agendaType.BLOCKED;

      if (isBusySlot || isBlocked) {
        if (isBusySlot) {
          const ownedByMe =
            item.ownerId === selectedOwnerId || item.ownerId === currentUserId;
          const hasCreator = createdByMe;
          const hasOwner =
            ownedByMe ||
            item.ownerId === selectedOwnerId ||
            item.ownerId === currentUserId;
          const noOwnerInfo = !item.createdById && !item.ownerId;
          const busySlotUserId = item.user?.id || item.userId;
          const slotBelongsToCurrentUser =
            busySlotUserId && busySlotUserId === currentUserId;

          // Allow if any ownership check passes (match WeeklyListView)
          return (
            hasCreator || hasOwner || noOwnerInfo || slotBelongsToCurrentUser
          );
        }
        // For blocked, still check createdById
        return createdByMe;
      }

      // For events (non-shifts) - check this LAST since shifts can have agendaType === EVENT
      if (
        item.agendaType === constants.agendaType.EVENT ||
        (!item.agendaType && !item.isShift)
      ) {
        return createdByMe;
      }

      return false;
    },
    [
      currentUserId,
      profile?.id,
      profile?.isAdmin,
      profile?.role,
      canEditAndViewOthersData,
      finalSelectedOwnerId,
      selectedOwnerId,
    ],
  );

  // Internal function to perform the actual event update
  const performEventUpdate = useCallback(
    async (eventData, newDateTime, editType, originalRequestedDate = null) => {
      if (!newDateTime || !eventData) {
        toastHot.error(t("scheduler.invalidEventData"));
        return;
      }

      const requestedDateForCheck = originalRequestedDate
        ? originalRequestedDate
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DD")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DD")
            : moment(eventData.date || newDateTime.newDate).format(
                "YYYY-MM-DD",
              );

      const dateChangedResult = matchedBothDatesValues({
        eventDetail: eventData,
        repeatedEndDate: eventData.repeatedEndDate
          ? moment(eventData.repeatedEndDate).toDate()
          : moment().add(3, "month").toDate(),
        requestedDate: requestedDateForCheck,
        eventDate: newDateTime.newDate,
      });

      const startTimeChanged = getTimeCheck(
        eventData.startTime,
        newDateTime.newStartTimeString,
      );
      const endTimeChanged = getTimeCheck(
        eventData.endTime,
        newDateTime.newEndTimeString,
      );

      const originalRequestedDateForParams = originalRequestedDate
        ? moment(originalRequestedDate).format("YYYY-MM-DDTHH:mm")
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DDTHH:mm")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DDTHH:mm")
            : moment(newDateTime.newDate).format("YYYY-MM-DDTHH:mm");

      const requestedDateForDateCalc = originalRequestedDate
        ? moment(originalRequestedDate).toDate()
        : eventData.requestedDate
          ? moment(eventData.requestedDate).toDate()
          : eventData.startTime
            ? moment(eventData.startTime).toDate()
            : null;

      const eventDate = moment(newDateTime.newDate).toDate();

      const originalDateForComparison = requestedDateForDateCalc
        ? moment(requestedDateForDateCalc).startOf("day")
        : eventData.startTime
          ? moment(eventData.startTime).startOf("day")
          : eventData.date
            ? moment(eventData.date).startOf("day")
            : null;

      const newDateForComparison = moment(eventDate).startOf("day");
      const dateActuallyChanged = originalDateForComparison
        ? !originalDateForComparison.isSame(newDateForComparison, "day")
        : dateChangedResult.startDateChanged;

      const finalIsEventDateChange =
        (editType === editTypesVariables.thisAndFutureEvent ||
          editType === editTypesVariables.allEvent) &&
        !dateActuallyChanged
          ? false
          : dateActuallyChanged;

      const params = {
        SchedulerEventId: eventData.id,
        OwnerId: finalSelectedOwnerId || profile?.id,
        Title: eventData.title,
        Date: moment(
          requestedDateForDateCalc &&
            moment(requestedDateForDateCalc)
              .startOf("day")
              .isSame(moment(eventDate).startOf("day"))
            ? eventData?.date
            : eventDate,
        ).format("YYYY-MM-DDTHH:mm"),
        StartTime: newDateTime.newStartTimeString,
        EndTime: newDateTime.newEndTimeString,
        IsAllDayEvent: eventData.isAllDayEvent || false,
        RepeatedType: eventData.repeatedType || 1,
        RepeatedDay: moment(newDateTime.newDate).isoWeekday(),
        RepeatedEndDate:
          eventData.repeatedType > 1 && eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).format("YYYY-MM-DD")
            : null,
        Location: eventData.location || "",
        BlockForPatient: eventData.blockForPatient || false,
        Note: eventData.note || "",
        PublishAsEvent: eventData.publishAsEvent || false,
        eventEmployees: Array.isArray(eventData.eventEmployees)
          ? eventData.eventEmployees
          : [],
        EventRoles: Array.isArray(eventData.eventRoles)
          ? eventData.eventRoles
          : [],
        EventTags: Array.isArray(eventData.eventTags)
          ? eventData.eventTags
          : [],
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
        ReminderBeforeInMins: eventData.reminderBeforeInMins || 0,
        isDraft: eventData.isDraft || false,
        requestedDate: originalRequestedDateForParams,
        timezoneCode: eventData.timezoneCode || moment.tz.guess(),
        EditType: editType || editTypesVariables.allEvent,
        UpdateFlags: {
          isTitleEdit: false,
          isStartTimeEdit: startTimeChanged,
          isEndTimeEdit: endTimeChanged,
          isAllDayEventEdit: false,
          isNoteEdit: false,
          isLocationEdit: false,
          isReminderBeforeInMinsEdit: false,
          isEnterpriseEdit: false,
          isOfficeIdEdit: false,
          EmployeeIds: [],
          RoleIds: [],
          IsRepeatTypeChange: false,
          IsEventDateChange: finalIsEventDateChange,
          IsRepeatedEndDateChange: dateChangedResult.endDateChanged,
          IsBlockForPatientChange: false,
          tagsIds: false,
        },
      };

      if (eventData.isShift) {
        params.Title = eventData.title || "";
        delete params.Location;
        delete params.Note;
        if (
          Array.isArray(eventData.eventEmployees) &&
          eventData.eventEmployees.length > 0 &&
          eventData.eventEmployees[0]
        ) {
          params.officeId = eventData.eventEmployees[0].officeId || null;
        }
      } else {
        params.IsAutoApprove = eventData.isAutoApprove || false;
      }

      try {
        setterCustomSchduler({
          params,
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||
            [],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||
            [],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });
      } catch (error) {
        console.warn("Error in setterCustomSchduler:", error);
      }

      try {
        const preferredOption = {
          dropdown: eventData.publishAsEvent
            ? [{ id: "allowInvitees" }]
            : eventData.isDraft
              ? [{ id: "saveDraft" }]
              : [{ id: "inviteesOnly" }],
          otherOptions: [],
        };
        setterPublishOffices({
          preferredOption,
          userIds: Array.isArray(eventData.eventEmployees)
            ? eventData.eventEmployees
            : [],
          publishAsEvent: eventData.publishAsEvent
            ? "allowInvitees"
            : eventData.isDraft
              ? "saveDraft"
              : "inviteesOnly",
          nonInviteesPublish: eventData.publishedType || "allOffices",
          params,
          officeIdForNonInvitee: Array.isArray(
            eventData.schedulerEventPublishedOffices,
          )
            ? eventData.schedulerEventPublishedOffices.filter(
                (office) => office && office.id,
              )
            : [],
          edit: true,
          isDraft: eventData.isDraft || false,
        });
      } catch (error) {
        console.warn("Error in setterPublishOffices:", error);
      }

      await createSchedulerEventMutation.mutateAsync(params);
      queryClient.invalidateQueries(["agenda"]);

      toastHot.success(t("staff.eventUpdated"));
    },
    [
      finalSelectedOwnerId,
      profile?.id,
      createSchedulerEventMutation,
      t,
      getTimeCheck,
      queryClient,
    ],
  );

  // Update event/shift via API (with EditEvent-style checks and modal)
  const updateEventAfterDrag = useCallback(
    async (eventItem, newDateTime, editType = null) => {
      if (!newDateTime || !eventItem || !eventItem.id) {
        toastHot.error(t("scheduler.invalidEventData"));
        return;
      }

      try {
        const originalRequestedDate = draggedEventDateRef.current
          ? draggedEventDateRef.current.format("YYYY-MM-DD")
          : moment(
              draggedEvent.requestedDate ||
                eventItem.startTime ||
                eventItem.date ||
                newDateTime.newDate,
            ).format("YYYY-MM-DD");
        const eventDetails = await getEventListDetails(
          eventItem.id,
          originalRequestedDate,
        );
        const eventData = eventDetails?.data;

        if (!eventData) {
          toastHot.error(t("scheduler.eventNotFound"));
          return;
        }

        const dateChangedResult = matchedBothDatesValues({
          eventDetail: eventData,
          repeatedEndDate: eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).toDate()
            : moment().add(3, "month").toDate(),
          requestedDate: originalRequestedDate,
          eventDate: newDateTime.newDate,
        });

        const repeatedOptionChanged = matchedBothPatternValues({
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||
            [],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||
            [],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });

        const anyChangedForDate =
          dateChangedResult.startDateChanged ||
          dateChangedResult.endDateChanged ||
          repeatedOptionChanged;

        const startTimeChanged = getTimeCheck(
          eventData.startTime,
          newDateTime.newStartTimeString,
        );
        const endTimeChanged = getTimeCheck(
          eventData.endTime,
          newDateTime.newEndTimeString,
        );

        const hasChanges =
          dateChangedResult.startDateChanged ||
          dateChangedResult.endDateChanged ||
          startTimeChanged ||
          endTimeChanged;

        const neverCheck =
          eventData.repeatedType ===
          addEditEventsConst.repeatedOptionsValues.never;
        if (!neverCheck && eventData.repeatedEndDate) {
          const newDateStr = moment(newDateTime.newDate).format("YYYY-MM-DD");
          const repeatedEndDateStr = moment(eventData.repeatedEndDate).format(
            "YYYY-MM-DD",
          );
          if (
            !moment(newDateStr).isBefore(repeatedEndDateStr) &&
            newDateStr !== repeatedEndDateStr
          ) {
            toastHot.error(t("form.errors.endGreater"));
            return;
          }
        }

        const isNotDrafted = !eventData.isDraft;

        if (!neverCheck && !editType && hasChanges && isNotDrafted) {
          setPendingDragUpdate({
            eventData,
            newDateTime,
            anyChangedForDate,
            originalRequestedDate,
          });
          setEditModalConfirmation(true);
          return;
        }

        let finalEditType = editType;
        if (!finalEditType) {
          if (neverCheck) {
            finalEditType = editTypesVariables.allEvent;
          } else {
            finalEditType = editTypesVariables.allEvent;
          }
        }

        await performEventUpdate(
          eventData,
          newDateTime,
          finalEditType,
          originalRequestedDate,
        );
      } catch (error) {
        toastHot.error(error.message || t("scheduler.updateFailed"));
        throw error;
      }
    },
    [t, getTimeCheck, performEventUpdate, draggedEvent],
  );

  // Internal function to perform the actual busy slot update
  const performBusySlotUpdate = useCallback(
    async (
      busySlotData,
      newDateTime,
      editType,
      officeDetails,
      officeIds,
      busySlotEmployeeView,
      isAllDayBusy,
      repeatedType,
      repeatedEndDate,
      originalRequestedDate,
      UpdateFlags,
    ) => {
      if (!newDateTime || !busySlotData) {
        toastHot.error(t("scheduler.invalidEventData"));
        return;
      }

      const eventDateMoment = moment(newDateTime.newDate);
      const startTime = moment(newDateTime.newStartTime);
      const endTime = moment(newDateTime.newEndTime);

      const requestedDateForDateCalc = originalRequestedDate
        ? moment(originalRequestedDate).toDate()
        : busySlotData.requestedDate
          ? moment(busySlotData.requestedDate).toDate()
          : busySlotData.startTime
            ? moment(busySlotData.startTime).toDate()
            : null;

      const eventDate = eventDateMoment.toDate();

      const params = {
        OwnerId: officeDetails.ownerId,
        OfficeIds: officeIds,
        Title: busySlotData.title || "",
        Date: moment(
          requestedDateForDateCalc &&
            moment(requestedDateForDateCalc)
              .startOf("day")
              .isSame(moment(eventDate).startOf("day"))
            ? busySlotData?.date
            : eventDate,
        ).format("YYYY-MM-DDTHH:mm"),
        StartTime: formatBusySlotTimeValue({
          eventDateMoment,
          isAllDayBusy,
          timeValue: startTime,
          startOrEnd: "startOf",
        }),
        EndTime: formatBusySlotTimeValue({
          eventDateMoment,
          isAllDayBusy,
          timeValue: endTime,
          startOrEnd: "endOf",
        }),
        repeatedType: +repeatedType,
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
        repeatedDay: +repeatedType === 1 ? null : eventDateMoment.isoWeekday(),
        RepeatedEndDate:
          +repeatedType === 1
            ? null
            : moment(repeatedEndDate).format("YYYY-MM-DD"),
        Location: busySlotData.location || "",
        Description: busySlotData.description || "",
        IsNotifyEmployee: busySlotData.isNotifyEmployee || false,
        BusySlotEmployeeView: busySlotEmployeeView,
        IsAllDayBusy: isAllDayBusy,
      };

      try {
        setterCustomSchduler({
          params,
          repeatedType: repeatedType,
          repeatedTypeFrequency: busySlotData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: busySlotData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            busySlotData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedSlotDate:
            busySlotData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||
            [],
          selectedWeek: busySlotData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            busySlotData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedMonths:
            busySlotData.customRepeatPattern?.monthsOfYear?.map(
              (m) => m?.month,
            ) || [],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: busySlotData,
        });
      } catch (error) {
        console.warn("Error in setterCustomSchduler:", error);
      }

      params.UpdateFlags = UpdateFlags;
      params.EditType = editType || 3;
      params.SchedulerBusySlotId = busySlotData.id;
      params.RequestedDate = originalRequestedDate;
      delete params.isRepeated;

      await updateBusySlot(params);
      await queryClient.invalidateQueries(["agenda"]);
      toastHot.success(t("scheduler.busySlotUpdated"));
    },
    [t, queryClient],
  );

  // Update busy slot via API
  const updateBusySlotAfterDrag = useCallback(
    async (eventItem, newDateTime, editType = null) => {
      if (!newDateTime || !eventItem || !eventItem.id) {
        toastHot.error(t("scheduler.invalidEventData"));
        return;
      }

      try {
        const originalRequestedDate = draggedEventDateRef.current
          ? draggedEventDateRef.current.format("YYYY-MM-DD")
          : moment(
              draggedEvent.requestedDate ||
                eventItem.startTime ||
                eventItem.date ||
                newDateTime.newDate,
            ).format("YYYY-MM-DD");

        let busySlotDetails = null;
        try {
          busySlotDetails = await getBusySlot({
            queryKey: [
              "busy-slot-details",
              eventItem.id,
              originalRequestedDate,
            ],
          });
        } catch (error) {
          toastHot.error(error.message || t("scheduler.updateFailed"));
          return;
        }

        const busySlotData = busySlotDetails?.data;

        if (!busySlotData) {
          toastHot.error(t("scheduler.eventNotFound"));
          return;
        }

        const officeId = busySlotData.officeId || eventItem.officeId;
        if (!officeId) {
          toastHot.error(t("scheduler.officeIdRequired"));
          return;
        }

        let officeDetails = null;
        try {
          officeDetails = await getOfficeDetail(officeId);
        } catch (error) {
          toastHot.error(
            error.message || t("scheduler.failedToFetchOfficeDetails"),
          );
          return;
        }

        if (!officeDetails) {
          toastHot.error(t("scheduler.officeDetailsNotFound"));
          return;
        }

        const isAllDayBusy =
          eventItem.isAllDayBusy ||
          eventItem.isAllDayEvent ||
          !eventItem.startTime ||
          !eventItem.endTime;

        // Build OfficeIds array - if schedulerBusySlotOffice exists, use it, otherwise create new
        let officeIds = [];
        if (
          busySlotData.schedulerBusySlotOffice &&
          Array.isArray(busySlotData.schedulerBusySlotOffice)
        ) {
          officeIds = busySlotData.schedulerBusySlotOffice.map((ele) => ({
            id: ele.externalId || ele.id || 0,
            SchedulerBusySlotId: busySlotData.id,
            OfficeId: ele.officeId,
            IsDeleted: false,
          }));
        } else {
          officeIds = [
            {
              id: 0,
              SchedulerBusySlotId: busySlotData.id,
              OfficeId: officeId,
              IsDeleted: false,
            },
          ];
        }

        // Build BusySlotEmployeeView
        const busySlotEmployeeView = (
          busySlotData.busySlotNotifiedUsers ||
          eventItem.busySlotNotifiedUsers ||
          []
        ).map((item) => ({
          userid: item.userId,
          OfficeId: item.officeId || officeId,
        }));

        const dateChangedResult = matchedBothDatesValues({
          eventDetail: busySlotData,
          repeatedEndDate: busySlotData.repeatedEndDate
            ? moment(busySlotData.repeatedEndDate).toDate()
            : moment().add(3, "month").toDate(),
          requestedDate: originalRequestedDate,
          eventDate: newDateTime.newDate,
        });

        const startTimeChanged = getTimeCheck(
          busySlotData.startTime,
          newDateTime.newStartTimeString,
        );
        const endTimeChanged = getTimeCheck(
          busySlotData.endTime,
          newDateTime.newEndTimeString,
        );

        const UpdateFlags = {
          isTitleEdit: false,
          isStartTimeEdit: startTimeChanged,
          isEndTimeEdit: endTimeChanged,
          isAllDayBusyEdit: false,
          isLocationEdit: false,
          isDescriptionEdit: false,
          isNotifyEmployeeEdit: false,
          IsBusySlotDateChange: dateChangedResult.startDateChanged,
          IsRepeatedEndDateChange: dateChangedResult.endDateChanged,
        };

        const neverCheck =
          busySlotData.repeatedType ===
          addEditEventsConst.repeatedOptionsValues.never;

        if (!neverCheck && !editType) {
          setPendingDragUpdate({
            eventData: busySlotData,
            newDateTime,
            anyChangedForDate: false,
            originalRequestedDate,
            isBusySlot: true,
            officeDetails,
            officeIds,
            busySlotEmployeeView,
            isAllDayBusy,
            repeatedType: busySlotData.repeatedType,
            repeatedEndDate: busySlotData.repeatedEndDate,
            UpdateFlags,
          });
          setEditModalConfirmation(true);
          return;
        }

        let finalEditType = editType;
        if (!finalEditType) {
          finalEditType = editTypesVariables.allEvent;
        }

        await performBusySlotUpdate(
          busySlotData,
          newDateTime,
          finalEditType,
          officeDetails,
          officeIds,
          busySlotEmployeeView,
          isAllDayBusy,
          busySlotData.repeatedType,
          busySlotData.repeatedEndDate,
          originalRequestedDate,
          UpdateFlags,
        );
      } catch (error) {
        toastHot.error(error.message || t("scheduler.updateFailed"));
        throw error;
      }
    },
    [t, getTimeCheck, performBusySlotUpdate, draggedEvent],
  );

  const eventCardView = (type, item, requestedDate, name, index) => {
    const data = getUsefulInfo(item);
    const searchKey = `${item?.id}_${requestedDate}`;
    const thisHoverKey = `${searchKey}_${index}`;
    const officeName = data?.officeName?.split(",")?.map((item) => {
      return {
        name: item,
        id: item,
      };
    });
    const colorType = boxBgColor(type, item);
    const colorCode =
      item?.user?.officeColourCodes?.[item?.officeId] || "#8C0346";
    const leaveCheck = type === constants.agendaType.LEAVE;
    const appointmentCheck = type === constants.agendaType.APPOINTMENT;

    let canDrag = false;
    if (
      (item.isShift ||
        type === constants.agendaType.EVENT ||
        type === constants.agendaType.BUSY_SLOT ||
        type === constants.agendaType.BLOCKED) &&
      !isFromDashBoard
    ) {
      canDrag = canDragEvent(item);
    }
    const isDragged = isDragging && draggedEvent?.eventItem?.id === item.id;
    let dragStarted = false;

    const handleDragStartLocal = (e) => {
      e.stopPropagation();
      if (!canDrag) {
        e.preventDefault();
        return;
      }
      dragStarted = true;
      handleDragStart(e, item, requestedDate);
    };

    const handleDragEndLocal = (e) => {
      dragStarted = false;
      handleDragEnd(e);
    };

    const goToDetailPage = (e) => {
      if (dragStarted) {
        e.preventDefault();
        e.stopPropagation();
        dragStarted = false;
        return;
      }
      if (isDragging) {
        e.stopPropagation();
        return;
      }
      let cardType = Object.keys(constants.agendaType)?.find(
        (key) => constants.agendaType[key] === type,
      );
      if (leaveCheck) {
        const isBeforeToday = moment(item?.startDate).isBefore(
          moment().startOf("day"),
        );
        if (item?.startDate && !isBeforeToday) {
          history.push({
            pathname: constants.routes.staff.editLeaves.replace(
              ":officeId",
              encodeId(item.officeId),
            ),
            state: { ...item, userId: profile.id, backRedirect: true },
          });
        } else if (isBeforeToday) {
          toast.error("You cannot edit the leaves for past dates");
        }
        return;
      }
      if (
        appointmentCheck ||
        // leaveCheck ||
        type === constants.agendaType.BLOCKED
      ) {
        setIsModal({ open: true, type: type, officeId: item?.officeId });
        return;
      }

      goToDetails(
        data.id,
        cardType,
        data?.createdByMe,
        data.isInvite,
        requestedDate,
      );
    };

    if (type === constants.agendaType.EVENT) {
      return (
        <div
          className={` ${styles["scheduler-event-box"]}  ${
            styles[data?.backgroudColorClass]
          }`}
          style={{
            cursor: canDrag ? "grab" : "pointer",
            opacity: isDragged ? 0.5 : 1,
            userSelect: "none",
            WebkitUserSelect: "none",
          }}
          draggable={canDrag}
          onDragStart={handleDragStartLocal}
          onDragEnd={handleDragEndLocal}
          onClick={goToDetailPage}
          onDragOver={(e) => {
            e.stopPropagation();
          }}
          onDrop={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <div className={styles["event-tag"] + " " + styles["theme-green-bg"]}>
            {item?.isShift
              ? t("scheduler.agenda.shiftTag")
              : t("scheduler.agenda.eventTag")}
          </div>
          {(!viewSettingFilter.length ||
            viewSettingFilter.includes("timeString")) && (
            <div className={styles["event-date"]}>
              {data?.timeString}({data?.timezoneCode})
            </div>
          )}

          {canShowOfficeName &&
            (!viewSettingFilter.length ||
              viewSettingFilter.includes("officeName")) && (
              <div className={styles["event-office"]}>{data?.officeName}</div>
            )}

          {!viewSettingFilter.length && data?.location && (
            <div className={styles["event-office"]}>
              <img
                src={require("assets/images/pin_drop_black.svg").default}
                alt="caret"
              />
              <span className="ml-1 break_all ">{data.location}</span>
            </div>
          )}

          {(!viewSettingFilter.length || viewSettingFilter.includes("title")) &&
            (item?.isShift ? (
              viewSettingFilter.includes("title") && (
                <div className={styles["event-user"] + " break"}>
                  {data?.title?.trim()
                    ? data.title
                    : t("scheduler.agenda.shiftTag")}
                </div>
              )
            ) : (
              <div className={styles["event-user"] + " break"}>
                {data?.title}
              </div>
            ))}

          {name &&
            (!viewSettingFilter.length ||
              viewSettingFilter.includes("staffMembers")) && (
              <div
                className={styles["event-user-container"]}
                style={{ backgroundColor: colorCode }}
              >
                <img
                  src={AccountImage}
                  alt="account"
                  className="account_owner_image"
                />
                <p className={styles.account_owner_name}>{name}</p>
              </div>
            )}
        </div>
      );
    }
    const { Highlighter, text } = leaveClasses(item?.statusId);
    const isBusySlot =
      type === constants.agendaType.BUSY_SLOT ||
      type === constants.agendaType.BLOCKED;
    // Check if can drag for busy slots
    let canDragBusySlot = false;
    if (isBusySlot && !isFromDashBoard) {
      canDragBusySlot = canDragEvent(item);
    }
    const isDraggedBusySlot =
      isDragging && draggedEvent?.eventItem?.id === item.id;
    let dragStartedBusySlot = false;

    const handleDragStartLocalBusySlot = (e) => {
      e.stopPropagation();
      if (!canDragBusySlot) {
        e.preventDefault();
        return;
      }
      dragStartedBusySlot = true;
      handleDragStart(e, item, requestedDate);
    };

    const handleDragEndLocalBusySlot = (e) => {
      dragStartedBusySlot = false;
      handleDragEnd(e);
    };

    const goToDetailPageBusySlot = (e) => {
      if (dragStartedBusySlot) {
        e.preventDefault();
        e.stopPropagation();
        dragStartedBusySlot = false;
        return;
      }
      if (isDragging) {
        e.stopPropagation();
        return;
      }
      goToDetailPage(e);
    };

    return (
      <div
        className={` ${styles["scheduler-event-box"]}  ${styles[colorType]} ${
          styles[data?.backgroudColorClass]
        }`}
        style={{
          cursor: canDragBusySlot ? "grab" : "pointer",
          opacity: isDraggedBusySlot ? 0.5 : 1,
          userSelect: "none",
          WebkitUserSelect: "none",
        }}
        draggable={canDragBusySlot}
        onDragStart={handleDragStartLocalBusySlot}
        onDragEnd={handleDragEndLocalBusySlot}
        onClick={goToDetailPageBusySlot}
        onDragOver={(e) => {
          e.stopPropagation();
        }}
        onDrop={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        {leaveCheck ? (
          <div className={styles["event-tag"] + " " + styles[Highlighter]}>
            {t(text)}
          </div>
        ) : appointmentCheck ? (
          <>
            <div className={styles["event-tag"] + " " + styles["dark-grey-bg"]}>
              {t("scheduler.agenda.appointmentTag")}
            </div>
            {data?.patientName && (
              <div className={styles["event-office"]}>{data?.patientName}</div>
            )}
          </>
        ) : (
          <div className={styles["event-tag"] + " " + styles["dark-orange-bg"]}>
            {t("scheduler.agenda.busyTag")}
          </div>
        )}
        {(!viewSettingFilter.length ||
          viewSettingFilter.includes("timeString")) &&
          (leaveCheck ? null : (
            <div className={styles["event-date"]}>{data?.timeString}</div>
          ))}
        {canShowOfficeName &&
          (!viewSettingFilter.length ||
            viewSettingFilter.includes("officeName")) && (
            <div className={styles["event-office"] + " position-relative"}>
              <MoreTagsFunction
                value={officeName || []}
                lastIndex={2}
                clickHandler={(e) =>
                  handlePopupToggle1(e, setNonInvitePopup, thisHoverKey)
                }
                parentClass="d-flex flex-wrap text-wrap text-break"
                mapFn={(member) => `${member?.name}`}
              />
              {hoverBusySlotKey == thisHoverKey && nonInvitePopup && (
                <InviteesPopup
                  position={invitePopupPosition}
                  handleInvitePopupToggle={(e) =>
                    handlePopupToggle1(e, setNonInvitePopup)
                  }
                  list={officeName}
                  showRoleAndOffice={false}
                  isForEvent={true}
                  isfromBusySlot={true}
                  onlyOfffice
                />
              )}{" "}
            </div>
          )}
        {!viewSettingFilter.length && data?.location && (
          <div className={styles["event-office"]}>
            <img
              src={require("assets/images/pin_drop_black.svg").default}
              alt="caret"
            />
            <span className="ml-1 break_all ">{data.location}</span>
          </div>
        )}
        {(!viewSettingFilter.length || viewSettingFilter.includes("title")) && (
          <div className={styles["event-user"] + " break"}>{data?.title}</div>
        )}

        {(!viewSettingFilter.length ||
          viewSettingFilter.includes("appointment")) &&
          type === constants.agendaType.APPOINTMENT && (
            <div className={styles["event-type"]}>
              {t("scheduler.agenda.appointmentTitle")}
            </div>
          )}
        {name &&
          (!viewSettingFilter.length || viewSettingFilter.includes("name")) &&
          type !== constants.agendaType.BLOCKED &&
          type !== constants.agendaType.BUSY_SLOT && (
            <div
              className={styles["event-user-container"]}
              style={{ backgroundColor: colorCode }}
            >
              <img
                src={AccountImage}
                alt="account"
                className="account_owner_image"
              />
              <p className={styles.account_owner_name}>{name}</p>
            </div>
          )}
      </div>
    );
  };

  // Handle drag start
  const handleDragStart = useCallback(
    (e, eventItem, requestedDate) => {
      if (!canDragEvent(eventItem)) {
        e.preventDefault();
        return;
      }

      let originalDate = null;
      if (eventItem.date) {
        originalDate = moment(eventItem.date).startOf("day");
      } else if (eventItem.startTime) {
        originalDate = moment(eventItem.startTime).startOf("day");
      }

      draggedEventDateRef.current = moment(requestedDate).startOf("day");

      const dragData = {
        eventItem,
        originalDate: originalDate ? originalDate.format("YYYY-MM-DD") : null,
        requestedDate: requestedDate
          ? moment(requestedDate).format("YYYY-MM-DD")
          : null,
      };

      setDraggedEvent(dragData);
      draggedEventRef.current = dragData;
      setIsDragging(true);

      const rect = e.currentTarget.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      const dragImage = e.currentTarget.cloneNode(true);
      dragImage.style.opacity = "0";
      dragImage.style.position = "absolute";
      dragImage.style.top = "-1000px";
      document.body.appendChild(dragImage);
      e.dataTransfer.setDragImage(dragImage, offsetX, offsetY);
      setTimeout(() => document.body.removeChild(dragImage), 0);
    },
    [canDragEvent],
  );

  // Handle drag over
  const handleDragOver = useCallback(
    (e, date) => {
      if (!draggedEvent) {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      e.dataTransfer.dropEffect = "move";

      if (date) {
        let formattedDate = date;
        if (date instanceof Date) {
          formattedDate = moment(date).format("YYYY-MM-DD");
        } else if (date && typeof date.format === "function") {
          formattedDate = date.format("YYYY-MM-DD");
        } else if (typeof date === "string") {
          const parsed = moment(date);
          formattedDate = parsed.isValid() ? parsed.format("YYYY-MM-DD") : date;
        }
        setDragPreviewDate(formattedDate);
      }
    },
    [draggedEvent],
  );

  // Handle drop
  const handleDrop = useCallback(
    async (e, targetDateString) => {
      e.preventDefault();
      e.stopPropagation();

      const currentDraggedEvent = draggedEventRef.current || draggedEvent;

      if (!currentDraggedEvent || !currentDraggedEvent.eventItem) {
        setIsDragging(false);
        setDraggedEvent(null);
        draggedEventRef.current = null;
        return;
      }

      const { eventItem } = currentDraggedEvent;
      if (!eventItem || !eventItem.id) {
        toastHot.error(t("scheduler.invalidEventData"));
        setIsDragging(false);
        setDraggedEvent(null);
        return;
      }

      let formattedDate = targetDateString;
      if (targetDateString instanceof Date) {
        formattedDate = moment(targetDateString).format("YYYY-MM-DD");
      } else if (
        targetDateString &&
        typeof targetDateString.format === "function"
      ) {
        formattedDate = targetDateString.format("YYYY-MM-DD");
      } else if (typeof targetDateString === "string") {
        const parsed = moment(targetDateString);
        if (parsed.isValid()) {
          formattedDate = parsed.format("YYYY-MM-DD");
        } else {
          console.error("Invalid date string:", targetDateString);
        }
      } else {
        const parsed = moment(targetDateString);
        if (parsed.isValid()) {
          formattedDate = parsed.format("YYYY-MM-DD");
        } else {
          console.error("Invalid date format:", targetDateString);
        }
      }

      // Check if dropped on same date - if so, don't call API
      const originalDateForCheck = currentDraggedEvent?.originalDate
        ? moment(currentDraggedEvent.originalDate).startOf("day")
        : eventItem.date
          ? moment(eventItem.date).startOf("day")
          : eventItem.startTime
            ? moment(eventItem.startTime).startOf("day")
            : null;

      if (
        originalDateForCheck &&
        moment(formattedDate).isSame(originalDateForCheck, "day")
      ) {
        setIsDragging(false);
        setDraggedEvent(null);
        draggedEventRef.current = null;
        setDragPreviewDate(null);
        return;
      }

      const newDateTime = calculateNewDateForMonthly(eventItem, formattedDate);

      if (!newDateTime) {
        setIsDragging(false);
        setDraggedEvent(null);
        return;
      }

      setIsDragDropLoading(true);
      try {
        const isBusySlot =
          eventItem.agendaType === constants.agendaType.BUSY_SLOT ||
          eventItem.agendaType === constants.agendaType.BLOCKED;

        if (isBusySlot) {
          await updateBusySlotAfterDrag(eventItem, newDateTime);
        } else {
          await updateEventAfterDrag(eventItem, newDateTime);
        }

        setPopupList({});
      } catch (error) {
        console.error("Error in drag update:", error);
      } finally {
        setIsDragDropLoading(false);
        setIsDragging(false);
        setDraggedEvent(null);
        draggedEventRef.current = null;
        setDragPreviewDate(null);
      }
    },
    [
      draggedEvent,
      calculateNewDateForMonthly,
      updateEventAfterDrag,
      updateBusySlotAfterDrag,
      t,
    ],
  );

  // Handle drag end
  const handleDragEnd = useCallback(() => {
    if (!isDragDropLoading) {
      setIsDragging(false);
      setDraggedEvent(null);
      draggedEventRef.current = null;
      setDragPreviewDate(null);
    }
  }, [isDragDropLoading]);

  const divRef = useRef(null);

  const tableData = useMemo(() => {
    if (filteredAgenda?.length) {
      return filteredAgenda.map((_item, index) => {
        let {
          requestedDate,
          appointments,
          leaves,
          schedulerBusySlots,
          schedulerEvents,
          appointmentSlots,
          holidayList,
        } = _item;
        appointments = appointments || [];
        leaves = leaves || [];
        schedulerBusySlots = (schedulerBusySlots || []).map((slot) => ({
          ...slot,
          type: "busySlot",
          isBusySlot: true,
          agendaType: slot.agendaType || constants.agendaType.BUSY_SLOT,
        }));
        schedulerEvents = schedulerEvents || [];
        appointmentSlots = appointmentSlots || [];
        const [allDayEvents, allOtherEvents] =
          splitAllDayAndTimedEvents(schedulerEvents);
        let allItems = [
          appointments,
          schedulerBusySlots,
          allOtherEvents,
          appointmentSlots,
        ]
          .flat()
          .sort((a, b) => {
            if (
              moment(moment(b.startTime).format("HH:mm"), "HH:mm").isAfter(
                moment(moment(a.startTime).format("HH:mm"), "HH:mm"),
              )
            ) {
              return -1;
            } else {
              return 1;
            }
          });
        allItems = [...leaves, ...allDayEvents, ...allItems];
        let allItemsCopy = JSON.parse(JSON.stringify(allItems));
        const isPastDate = moment(requestedDate).isBefore(
          moment().startOf("day"),
        );

        const highlightCheck =
          dateMatchForHighlight &&
          moment(dateMatchForHighlight)
            .startOf("day")
            .isSame(moment(requestedDate).startOf("day"));
        if (!allItems || !allItems?.length) {
          return (
            <div
              ref={highlightCheck ? divRef : undefined}
              className={
                styles["monthly-col"] +
                (holidayList?.length > 0 ? ` ${styles["light-red-bg"]}` : "") +
                ` ${highlightCheck ? "blinking-background " : ""}` +
                styles["monthly-td"]
              }
              key={moment(requestedDate).format("YYYY-MM-DD hh:mm a")}
              onDragOver={(e) => {
                if (handleDragOver) {
                  handleDragOver(e, requestedDate);
                }
              }}
              onDragLeave={(e) => {
                const relatedTarget = e.relatedTarget;
                if (
                  !relatedTarget ||
                  !e.currentTarget.contains(relatedTarget)
                ) {
                  if (setDragPreviewDate) {
                    setDragPreviewDate(null);
                  }
                }
              }}
              onDrop={(e) => {
                if (handleDrop) {
                  handleDrop(e, requestedDate);
                }
              }}
            >
              <div className={styles["date-box"]}>
                {moment(requestedDate).format("DD")}
                {!isPastDate && (
                  <UncontrolledDropdown
                    className={styles.ellipsis_position_dots_new}
                  >
                    <DropdownToggle
                      caret={false}
                      tag="div"
                      className="cursor-pointer"
                    >
                      <div
                        className={styles.ellipsis_icon + " " + `ellipsis-icon`}
                      >
                        <ThreeDots />
                      </div>
                    </DropdownToggle>
                    <DropdownMenu
                      right
                      className={styles["office-dropdown-menu"]}
                    >
                      {isStaff && (
                        <DropdownItem
                          className={styles["office-dropdown-item"]}
                          onClick={() => {
                            setShowOfficeSelectModal(true);
                            setSelectedDateForLeave(currentDate);
                          }}
                        >
                          {t("staffLeaves.applyLeave")}
                        </DropdownItem>
                      )}
                      <DropdownItem
                        className={styles["office-dropdown-item"]}
                        onClick={() => {
                          history.push({
                            pathname: constants.routes.scheduler.addBusySlot,
                            state: {
                              date: currentDate,
                            },
                          });
                        }}
                      >
                        {t("accountOwner.addBusyslots")}
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}
              </div>
              {holidayList?.length > 0 && (
                <div className={styles["holiday_title"]}>
                  <img
                    src={HolidayImage}
                    alt="holiday"
                    className="account_owner_image"
                  />
                  <div className={styles.holiday_title_text}>
                    {holidayList?.[0]?.title}
                  </div>
                </div>
              )}
              {/* Drag Preview Card for empty cells */}
              {isDragging &&
              draggedEvent?.eventItem &&
              dragPreviewDate &&
              moment(requestedDate).format("YYYY-MM-DD") === dragPreviewDate ? (
                <div
                  className={styles["scheduler-event-box"]}
                  style={{
                    backgroundColor: "#C8E36433",
                    border: "2px dashed #C8E364",
                    borderRadius: "6px",
                    opacity: 0.6,
                    pointerEvents: "none",
                    marginBottom: "4px",
                  }}
                >
                  <div className="d-flex justify-content-between">
                    <div className="d-flex gap-1">
                      {draggedEvent.eventItem.agendaType ===
                        constants.agendaType.EVENT && (
                        <div
                          className={
                            styles["event-tag"] + " " + styles["theme-green-bg"]
                          }
                          style={{ opacity: 0.6 }}
                        >
                          {draggedEvent.eventItem?.isShift
                            ? t("scheduler.agenda.shiftTag")
                            : t("scheduler.agenda.eventTag")}
                        </div>
                      )}
                      {(draggedEvent.eventItem.agendaType ===
                        constants.agendaType.BUSY_SLOT ||
                        draggedEvent.eventItem.agendaType ===
                          constants.agendaType.BLOCKED) && (
                        <div
                          className={
                            styles["event-tag"] + " " + styles["dark-orange-bg"]
                          }
                          style={{ opacity: 0.6 }}
                        >
                          {t("scheduler.agenda.busyTag")}
                        </div>
                      )}
                    </div>
                  </div>
                  {(!viewSettingFilter.length ||
                    viewSettingFilter.includes("timeString")) && (
                    <div
                      className={styles["event-date"]}
                      style={{ opacity: 0.6 }}
                    >
                      {draggedEvent.eventItem?.isAllDayEvent ||
                      draggedEvent.eventItem?.isAllDayBusy
                        ? t("scheduler.agenda.allDayEvent")
                        : draggedEvent.eventItem?.startTime &&
                            draggedEvent.eventItem?.endTime
                          ? moment(draggedEvent.eventItem?.startTime).format(
                              "h:mm A",
                            ) +
                            " - " +
                            moment(draggedEvent.eventItem?.endTime).format(
                              "h:mm A",
                            )
                          : ""}
                      {draggedEvent.eventItem?.timezoneCode &&
                        ` (${draggedEvent.eventItem?.timezoneCode})`}
                    </div>
                  )}
                  {(!viewSettingFilter.length ||
                    viewSettingFilter.includes("title")) && (
                    <div
                      className={styles["event-user"]}
                      style={{ opacity: 0.6 }}
                      title={draggedEvent.eventItem?.title}
                    >
                      {draggedEvent.eventItem?.title?.length > 20
                        ? draggedEvent.eventItem?.title
                            .slice(0, 20)
                            .concat(" ...")
                        : draggedEvent.eventItem?.title}
                    </div>
                  )}
                </div>
              ) : (
                <div className={styles["empty-event"]}></div>
              )}
            </div>
          );
        }
        return (
          <div
            ref={highlightCheck ? divRef : undefined}
            className={`${styles["monthly-col"]} ${
              holidayList?.length > 0 ? styles["light-red-bg"] : ""
            } ${styles["monthly-td"]}${
              highlightCheck ? " blinking-background" : ""
            } ${popupList?.date === requestedDate && styles["active-date"]}`}
            onDragOver={(e) => {
              if (handleDragOver) {
                handleDragOver(e, requestedDate);
              }
            }}
            onDragLeave={(e) => {
              const relatedTarget = e.relatedTarget;
              if (!relatedTarget || !e.currentTarget.contains(relatedTarget)) {
                if (setDragPreviewDate) {
                  setDragPreviewDate(null);
                }
              }
            }}
            onDrop={(e) => {
              if (handleDrop) {
                handleDrop(e, requestedDate);
              }
            }}
          >
            <div className={styles["more-event-box"]}>
              {allItems.splice(0, 2).map((list, childIndex) => {
                const name = `${
                  list?.user
                    ? (list?.user?.firstName || "") +
                      " " +
                      (list?.user?.lastName || "")
                    : ""
                }`.trim();
                return (
                  <>
                    {!childIndex && (
                      <div className={styles["date-box"]}>
                        {moment(requestedDate).format("DD")}
                        {!isPastDate && (
                          <UncontrolledDropdown
                            className={styles.ellipsis_position_dots_new}
                          >
                            <DropdownToggle
                              caret={false}
                              tag="div"
                              className="cursor-pointer"
                            >
                              <div
                                className={
                                  styles.ellipsis_icon + " " + `ellipsis-icon`
                                }
                              >
                                <ThreeDots />
                              </div>
                            </DropdownToggle>
                            <DropdownMenu
                              right
                              className={styles["office-dropdown-menu"]}
                            >
                              {isStaff && (
                                <DropdownItem
                                  className={styles["office-dropdown-item"]}
                                  onClick={() => {
                                    setShowOfficeSelectModal(true);
                                    setSelectedDateForLeave(currentDate);
                                  }}
                                >
                                  {t("staffLeaves.applyLeave")}
                                </DropdownItem>
                              )}
                              <DropdownItem
                                className={styles["office-dropdown-item"]}
                                onClick={() => {
                                  history.push({
                                    pathname:
                                      constants.routes.scheduler.addBusySlot,
                                    state: {
                                      date: currentDate,
                                    },
                                  });
                                }}
                              >
                                {t("accountOwner.addBusyslots")}
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        )}
                        <span className={styles["day-box"]}>
                          ({getWeekDay(requestedDate)})
                        </span>
                      </div>
                    )}
                    {!childIndex && holidayList?.length > 0 && (
                      <div className={styles["holiday_title"]}>
                        <img
                          src={HolidayImage}
                          alt="holiday"
                          className="account_owner_image"
                        />
                        <div className={styles.holiday_title_text}>
                          {holidayList?.[0]?.title}
                        </div>
                      </div>
                    )}
                    {list?.agendaType &&
                      eventCardView(
                        list?.agendaType,
                        list,
                        requestedDate,
                        name,
                        index,
                      )}

                    {allItemsCopy?.length > 2 && childIndex === 1 && (
                      <span
                        className={"link-btn"}
                        onClick={() =>
                          handleEventList(
                            allItems,
                            list,
                            index,
                            childIndex,
                            requestedDate,
                          )
                        }
                      >
                        {" "}
                        See more{" "}
                      </span>
                    )}

                    {popupList?.id === parseInt(list.id) + index + childIndex &&
                      index === popupList?.index &&
                      popupList?.item?.length > 0 && (
                        <div
                          className={
                            styles["monthly-event-list"] +
                            " " +
                            (holidayList?.length > 0
                              ? styles["light-red-bg"]
                              : "")
                          }
                        >
                          <span
                            className={styles["close-icon-list"]}
                            onClick={() => setPopupList({})}
                          >
                            <img
                              src={
                                require("assets/images/close-grey.svg").default
                              }
                              alt="icon"
                            />
                          </span>
                          <div className={styles["day-date-box"]}>
                            <div className={styles["day-name"]}>
                              {" "}
                              {getWeekDay(requestedDate)}
                            </div>
                            <div className={styles["date-name"]}>
                              {" "}
                              {moment(requestedDate).format("D")}
                            </div>
                          </div>
                          <div className={styles["event-list-ul"]}>
                            {popupList?.item?.map((data) => {
                              const name = `${
                                list?.user
                                  ? (list?.user?.firstName || "") +
                                    " " +
                                    (list?.user?.lastName || "")
                                  : ""
                              }`.trim();
                              return (
                                <>
                                  {data?.agendaType &&
                                    eventCardView(
                                      data?.agendaType,
                                      data,
                                      requestedDate,
                                      name,
                                      index,
                                    )}
                                </>
                              );
                            })}
                          </div>
                        </div>
                      )}
                  </>
                );
              })}
            </div>
            {isDragging &&
              draggedEvent?.eventItem &&
              dragPreviewDate &&
              moment(requestedDate).format("YYYY-MM-DD") ===
                dragPreviewDate && (
                <div
                  className={styles["scheduler-event-box"]}
                  style={{
                    backgroundColor: "#C8E36433",
                    border: "2px dashed #C8E364",
                    borderRadius: "6px",
                    opacity: 0.6,
                    pointerEvents: "none",
                    marginBottom: "4px",
                  }}
                >
                  <div className="d-flex justify-content-between">
                    <div className="d-flex gap-1">
                      {draggedEvent.eventItem.agendaType ===
                        constants.agendaType.EVENT && (
                        <div
                          className={
                            styles["event-tag"] + " " + styles["theme-green-bg"]
                          }
                          style={{ opacity: 0.6 }}
                        >
                          {draggedEvent.eventItem?.isShift
                            ? t("scheduler.agenda.shiftTag")
                            : t("scheduler.agenda.eventTag")}
                        </div>
                      )}
                      {(draggedEvent.eventItem.agendaType ===
                        constants.agendaType.BUSY_SLOT ||
                        draggedEvent.eventItem.agendaType ===
                          constants.agendaType.BLOCKED) && (
                        <div
                          className={
                            styles["event-tag"] + " " + styles["dark-orange-bg"]
                          }
                          style={{ opacity: 0.6 }}
                        >
                          {t("scheduler.agenda.busyTag")}
                        </div>
                      )}
                    </div>
                  </div>
                  {(!viewSettingFilter.length ||
                    viewSettingFilter.includes("timeString")) && (
                    <div
                      className={styles["event-date"]}
                      style={{ opacity: 0.6 }}
                    >
                      {draggedEvent.eventItem?.isAllDayEvent ||
                      draggedEvent.eventItem?.isAllDayBusy
                        ? t("scheduler.agenda.allDayEvent")
                        : draggedEvent.eventItem?.startTime &&
                            draggedEvent.eventItem?.endTime
                          ? moment(draggedEvent.eventItem?.startTime).format(
                              "h:mm A",
                            ) +
                            " - " +
                            moment(draggedEvent.eventItem?.endTime).format(
                              "h:mm A",
                            )
                          : ""}
                      {draggedEvent.eventItem?.timezoneCode &&
                        ` (${draggedEvent.eventItem?.timezoneCode})`}
                    </div>
                  )}
                  {(!viewSettingFilter.length ||
                    viewSettingFilter.includes("title")) && (
                    <div
                      className={styles["event-user"]}
                      style={{ opacity: 0.6 }}
                      title={draggedEvent.eventItem?.title}
                    >
                      {draggedEvent.eventItem?.title?.length > 20
                        ? draggedEvent.eventItem?.title
                            .slice(0, 20)
                            .concat(" ...")
                        : draggedEvent.eventItem?.title}
                    </div>
                  )}
                </div>
              )}
          </div>
        );
      });
    }
    return null;
  }, [
    filteredAgenda,
    popupList,
    viewSettingFilter,
    hoverBusySlotKey,
    isDragging,
    draggedEvent,
    dragPreviewDate,
    handleDragOver,
    handleDrop,
    setDragPreviewDate,
    effectiveOwnerIdString,
  ]);
  useEffect(() => {
    if (!search || !agenda?.length || !tableData) return;
    if (divRef.current) {
      setTimeout(() => {
        divRef.current.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "center",
        });
      }, 500);
    }
    const timeOut = setTimeout(() => {
      const queryParams = new URLSearchParams(search);
      if (queryParams.has(showTime)) {
        queryParams.delete(showTime);
        history.replace({
          search: queryParams.toString(),
        });
      }
    }, 3000);
    return () => {
      clearTimeout(timeOut);
    };
  }, [search, tableData]);
  return (
    <div
      className={styles["montly-calendar-wrapper"] + " h-100"}
      style={isFromDashBoard ? { maxHeight: "unset" } : {}}
    >
      <div className={styles["monthly-tr"]}>
        {(isLoading || isDragDropLoading) && <Loader />}
        {weekDays?.map((item) => (
          <div
            className={
              styles["monthly-th"] +
              " " +
              styles["monthly-col"] +
              " border-right-none"
            }
          >
            {item.slice(0, 3)}
          </div>
        ))}
      </div>

      <div className={styles["monthly-tr"]}>
        {tableData}
        {isModal?.open && (
          <MoveToApp
            isModal={isModal?.open}
            openModal={setIsModal}
            type={isModal?.type}
            officeId={isModal?.officeId || null}
          />
        )}
      </div>
      {showOfficeSelectModal && (
        <SelectOfficeModal
          selectedOwnerId={selectedOwnerId}
          showOfficeSelectModal={showOfficeSelectModal}
          setShowOfficeSelectModal={setShowOfficeSelectModal}
          SelectedDateForLeave={SelectedDateForLeave}
        />
      )}
      {editModalConfirmation && pendingDragUpdate && (
        <EditOptionsModal
          isOpen={editModalConfirmation}
          closeStepOneModal={setEditModalConfirmation}
          loader={false}
          eventKey={
            pendingDragUpdate.isBusySlot
              ? {
                  eventOrShift: t("accountOwner.busySlot").toLowerCase(),
                }
              : {
                  eventOrShift: t(
                    `accountOwner.${
                      pendingDragUpdate.eventData?.isShift ? "shift" : "event"
                    }Tab`,
                  ).toLowerCase(),
                }
          }
          eventOrShiftTab={
            pendingDragUpdate.isBusySlot
              ? false
              : pendingDragUpdate.eventData?.isShift || false
          }
          busySlots={pendingDragUpdate.isBusySlot || false}
          repeatedOptionChanged={pendingDragUpdate.anyChangedForDate || false}
          handleConfirm={async (value) => {
            try {
              if (pendingDragUpdate.isBusySlot) {
                await performBusySlotUpdate(
                  pendingDragUpdate.eventData,
                  pendingDragUpdate.newDateTime,
                  value,
                  pendingDragUpdate.officeDetails,
                  pendingDragUpdate.officeIds,
                  pendingDragUpdate.busySlotEmployeeView,
                  pendingDragUpdate.isAllDayBusy,
                  pendingDragUpdate.repeatedType,
                  pendingDragUpdate.repeatedEndDate,
                  pendingDragUpdate.originalRequestedDate,
                  pendingDragUpdate.UpdateFlags,
                );
              } else {
                await performEventUpdate(
                  pendingDragUpdate.eventData,
                  pendingDragUpdate.newDateTime,
                  value,
                  pendingDragUpdate.originalRequestedDate,
                );
              }
              setEditModalConfirmation(false);
              setPendingDragUpdate(null);
            } catch (error) {
              setEditModalConfirmation(false);
              setPendingDragUpdate(null);
            }
          }}
        />
      )}
    </div>
  );
}

export default withTranslation()(MonthlyViewNew);
